import { DateTime } from 'luxon';

import { transactionsTransformers } from '../transactions';
import type { TransactionProps } from '../transactions/transactionsTypes';
import {
  type ScheduledTransaction,
  type ScheduledTransactionType,
  mkScheduledTransaction,
} from './scheduledTransactionsTypes';

// request transform
export const transformScheduledTransactionToRequestData = (
  resource: ScheduledTransaction | ScheduledTransactionType | null | undefined,
) => {
  const updatedatedResource = {
    ...(resource && 'toJS' in resource ? (resource.toJS() as ScheduledTransactionType) : resource),
    ...(resource?.recurrence && {
      recurrence: {
        ...(('toJS' in resource.recurrence && resource.recurrence?.toJS?.()) || resource.recurrence),
        endOn: DateTime.isDateTime(resource.recurrence.endOn)
          ? resource.recurrence.endOn.toISODate()
          : resource.recurrence.endOn,
      },
    }),
    ...(resource?.transaction && {
      transaction: transactionsTransformers.transformTransactionToRequestData(resource.transaction),
    }),
  } as ScheduledTransactionType;

  // byMonthDayOrLastDay has been deprecated in favor of byMonthDay, adjust any old recurrences or recurrrences from agggregation
  if (updatedatedResource.recurrence?.byMonthDayOrLastDay) {
    updatedatedResource.recurrence = {
      ...updatedatedResource.recurrence,
      byMonthDay:
        updatedatedResource.recurrence?.byMonthDay && updatedatedResource.recurrence?.byMonthDay.length > 0
          ? updatedatedResource.recurrence.byMonthDay.concat(updatedatedResource.recurrence.byMonthDayOrLastDay)
          : updatedatedResource.recurrence.byMonthDayOrLastDay,
      byMonthDayOrLastDay: undefined, // remove the old prop
      byDay: undefined, // remove conflicting prop
      byDates: undefined, // remove conflicting prop
    };
  }

  return updatedatedResource;
};

// response transform
export const transformDataToScheduledTransaction = (
  data: { transaction?: TransactionProps | null } | null | undefined,
) =>
  mkScheduledTransaction({
    ...data,
    ...{ type: undefined },
    transaction: data?.transaction
      ? transactionsTransformers.transformQcsTransactionToTransaction(data.transaction)
      : null,
  });
